export default LinearGradient = () => null
